import styled from 'styled-components';

export const Container = styled.div`
  & > div.table-container {
    margin: 1rem 1.5rem;
  }
`;
